import { ChevronLeft, ChevronRight } from "lucide-react";
import { FC } from "react";

type HeaderProps = {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  prevMonthButtonDisabled?: boolean;
  nextMonthButtonDisabled?: boolean;
};

const CalendarHeader: FC<HeaderProps> = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => (
  <div className="flex items-center justify-between px-4 py-3">
    <button
      type="button"
      aria-label="Previous Month"
      onClick={decreaseMonth}
      disabled={prevMonthButtonDisabled}
      className="h-12 w-12 rounded-full bg-gray-100 text-gray-700 disabled:opacity-40 flex items-center justify-center"
    >
      <ChevronLeft/>
    </button>
    <div className="calendar-month">
      {date.toLocaleString(undefined, { month: "long", year: "numeric" })}
    </div>
    <button
      type="button"
      aria-label="Next Month"
      onClick={increaseMonth}
      disabled={nextMonthButtonDisabled}
      className="h-12 w-12 rounded-full bg-gray-100 text-gray-700 disabled:opacity-40 disabled:bg-transparent flex items-center justify-center"
    >
      <ChevronRight className=""/>
    </button>
  </div>
);

export default CalendarHeader;

